import React from 'react';
import { MuiColorInput } from 'mui-color-input';
import { Box, IconButton, InputAdornment } from '@mui/material';
import {
    convertColorToARGB,
    convertColorToRGBA
} from '../../utils/formatGradient';
import Iconify from '../iconify';

export class GradientEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            colorStops: props.colorStops || [{ A: 1, R: 255, G: 255, B: 255 }]
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (props.colorStops !== state.colorStops) {
            return {
                colorStops: props.colorStops || [{ A: 1, R: 255, G: 255, B: 255 }]
            };
        }
        return null;
    }
    handleChangeColor = (index, color) => {
        const newColor = convertColorToARGB(color);
        const newColorStops = [...this.state.colorStops];
        newColorStops[index] = newColor;
        if (index === newColorStops.length - 1 && newColorStops.length < 3) {
            newColorStops.push({ A: 1, R: 255, G: 255, B: 255 });
        }
        this.setState({ colorStops: newColorStops });
        this.props.onChange(newColorStops);
    };
    render() {
        return (
            <Box>
                <Box display="flex" justifyContent="space-between" gap={2}>
                    {this.state.colorStops.map((color, index) => (
                        <MuiColorInput
                            key={index}
                            sx={{ width: '210px' }}
                            margin="dense"
                            value={convertColorToRGBA(color)}
                            onChange={(newColor) =>
                                this.handleChangeColor(index, newColor)
                            }
                            // first color is not removable
                            InputProps={{
                                endAdornment:
                                    this.state.colorStops.length > 1 &&
                                    index !== 0 ? (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => {
                                                        this.setState(
                                                            (prevState) => {
                                                                const newColorStops =
                                                                [
                                                                    ...prevState.colorStops
                                                                ];
                                                                newColorStops.splice(
                                                                    index,
                                                                    1
                                                                );
                                                                return {
                                                                    colorStops:
                                                                    newColorStops
                                                                };
                                                            }
                                                        );
                                                    }}
                                                >
                                                    <Iconify icon="eva:close-fill" />
                                                </IconButton>
                                            </InputAdornment>
                                        ) : null
                            }}
                        />
                    ))}
                </Box>

                {this.state.colorStops.length > 1 && (
                    <div
                        style={{
                            width: '100%',
                            height: '40px',
                            background: `linear-gradient(to right, ${this.state.colorStops
                                .map((color) => convertColorToRGBA(color))
                                .join(',')})`
                        }}
                    ></div>
                )}
            </Box>
        );
    }
}
